/********************************************************************
 *  Copyright 2025 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  Adobe permits you to use, modify, and distribute this 
 * file in accordance with the terms of the Adobe license agreement 
 * accompanying it. 
 *******************************************************************/

export const INITIATE_UPLOAD_MUTATION = `
  mutation INITIATE_UPLOAD_MUTATION($input: initiateUploadInput!) {
    initiateUpload(input: $input) {
      upload_url
      key
      expires_at
    }
  }
`;